const DateIcon = ({ width = 28, height = 28, color = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66406 23.3346L4.66406 8.16797L23.3307 8.16797L23.3307 23.3346L4.66406 23.3346Z"
        stroke={color}
        strokeWidth="2.63"
      />
      <path d="M8.16406 12.832H12.8307" stroke={color} strokeWidth="2.63" />
      <path d="M9.33594 7.0013V4.66797" stroke={color} strokeWidth="2.63" />
      <path d="M19.8359 7.0013V4.66797" stroke={color} strokeWidth="2.63" />
    </svg>
  )
}

export default DateIcon
